// extracted by mini-css-extract-plugin
export default {"default":"Button_default__eKvLX","projects":"Button_projects__b5mSl","imageLink":"Button_imageLink__hUkJd"};